import { ApiService } from "@/api";

export const aggStatusAll = () => {
  return ApiService.baseAction("agg/status", {}, "GET");
};
